<template>
  <el-card class="card-main">
    <el-form ref="searchInfo" :model="searchForm" class="global-form" :inline="true">
      <el-form-item>
        <el-select v-model="searchForm.projectId" placeholder="请选择所属项目" filterable clearable>
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch" class="medium">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table class="global-table" height="600px" stripe :data="tableData" v-loading="loading">
      <el-table-column label="项目名称" prop="projectName" show-overflow-tooltip></el-table-column>
      <el-table-column label="已设置区域数" prop="areaNum" show-overflow-tooltip></el-table-column>
      <el-table-column label="电磁阀" prop="valveNum" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="400px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="$router.push(`/irrigation2/detail?projectId=${row.projectId}`)">点击进入</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>

export default {
  name: 'IrrigationManage',
  data () {
    return {
      itemList: [
        {
          label: '项目名称',
          prop: 'projectName'
        }
      ],

      searchForm: {
        projectId: ''
      },

      tableData: [],
      loading: false
    }
  },
  computed: {

    projectList () {
      return this.$store.state.projectList
    }
  },

  created () {
    this.getList()
  },
  methods: {

    getList () {
      this.loading = true
      this.$axios.get(this.$apis.irrigation.selectIrrigationProjectWebList, this.searchForm).then(res => {
        this.tableData = res
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch () {
      this.getList()
    }
  }

}
</script>

<style scoped lang="scss"></style>
